import React from 'react';

import { PERMISSAO_TELA_DASHBOARD_LISTAR } from '../../utils/dadosTelas';
import { ProtegerPagina } from '../VerificaPermissaoPage';

const DashbboardContabilidade = () => (
  <ProtegerPagina permissao={PERMISSAO_TELA_DASHBOARD_LISTAR}>
    <div>Dashboard contabilidade</div>
  </ProtegerPagina>
);

export default DashbboardContabilidade;
